import $ from 'jquery';

import View from './view';

export default View.extend( {
    events: {
        'click li': function({currentTarget}) {
            const $li = this.$( currentTarget );
            if ($li.hasClass( 'active' ))
                return;

            this.$( 'li' ).removeClass( 'active' );
            $li.addClass( 'active' );

            const tabNames = this.$( 'a' ).toArray().map( a => a.href.substr( a.href.indexOf( '#' ) + 1 ) ),
                tabName = $li.find( 'a' ).attr( 'href' ).substr( 1 );

            tabNames.map( name => $( `[name="Tab-${name}"]` ) )
                .forEach( $el => $el.addClass( 'hide' ) );
            $( `[name="Tab-${tabName}"]` ).removeClass( 'hide' );
        },
    },
} );


// WEBPACK FOOTER //
// ./src/js/view/tab.pills.js